import React from 'react';
import { useGetOne, useGetMany, useGetManyReference, SelectInput, required as validateRequired, Identifier } from 'react-admin';
import { Contract } from '../types';

interface ClientSelectListProps {
  contract?: Contract;
  funeral_id?: Identifier;
  source?: string;
  required?: boolean;
}

export const ClientSelectList: React.FC<ClientSelectListProps> = ({
  contract,
  funeral_id,
  source = "client_id",
  required = true
}) => {
  const id = contract ? contract.funeral_id : funeral_id;

  const { data: funeral, isLoading: isLoadingFuneral } = useGetOne(
    'funerals',
    { id },
    { enabled: !!id }
  );

  const { data: funeral_clients, isLoading: isLoadingFuneralClients } = useGetManyReference(
    'funeral_clients',
    { target: 'funeral_id', id: funeral?.id },
    { enabled: !isLoadingFuneral }
  );

  const { data: clients, isLoading: isLoadingClients } = useGetMany(
    'clients',
    {
      ids: funeral ? [funeral.primary_client_id].concat(funeral_clients?.map(fc => fc.client_id) || []) : [],
    },
    { enabled: !isLoadingFuneralClients && !!funeral_clients }
  );

  if (isLoadingFuneral || isLoadingFuneralClients || isLoadingClients) {
    return null;
  }

  return (
    <SelectInput
      source={source}
      choices={clients}
      optionText="name"
      optionValue="id"
      validate={required ? [validateRequired()] : undefined}
    />
  );
};
